import ListSkills from "../components/ListSkills";

const Skills = () => {
  return (
  <div className="min-h-screen bg-white">
    <div className="bg-[#55ad6d] min-h-screen p-20 max-w-6xl mx-auto">
      <div className="flex flex-rows gap-6 items-start justify-center mt-5">
        <ListSkills></ListSkills>
      </div>
    </div>
  </div>)
};

export default Skills;
